import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'
import { darken, lighten } from 'polished'
import { Link } from 'gatsby'
import theme from 'src/utils/styles/theme'

export const CountdownSection = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.frame ? `-8px` : 'auto')};
  // Styling this outside the Section container leads to order and specificity issues in production after bundling/minification
  & .countdown-background-image {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;
    z-index: 1;
    height: 100% !important;
    min-height: 100%;
    object-fit: cover;
  }
  @media (max-width: 1400px) {
    margin-top: ${(props) => (props.frame ? `64px` : 'auto')};
  }
  @media (max-width: ${breakpoints.xl}px) {
    margin-top: ${(props) => (props.frame ? `46px` : 'auto')};
  }
  @media (max-width: ${breakpoints.l}px) {
    margin-top: ${(props) => (props.frame ? `40px` : '0px')};
    & .countdown-background-image {
      position: absolute !important;
      top: 0;
      left: 0;
      width: 100% !important;
      z-index: 1;
      height: 100% !important;
      min-height: 100%;
      object-fit: cover;
    }
  }
  @media (max-width: ${breakpoints.s}px) {
    display: block;
    margin-top: ${(props) => (props.marginTop ? `32px` : '0px')};
    padding: 32px;
    object-fit: cover;
    margin-bottom: -20px;
  }
`

export const CountdownSectionContainer = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 140px;
  text-align: center;
  padding: 36px 0px;
  @media (max-width: ${breakpoints.l}px) {
    flex-direction: column;
    row-gap: 8px;
    width: 100%;
    padding: 32px 0px;
  }
  @media (max-width: ${breakpoints.s}px) {
    padding: 0px;
  }
`
export const Header = styled.h2`
  margin: 0px;
  color: ${(props) => props.headerColor || theme.white};
  text-align: center;
  font-family: 'P22MackinacProBold';
  font-size: 32px;
  font-style: normal;
  line-height: 140%;
  letter-spacing: 3.423px;
  margin-bottom: 16px;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 24px;
    letter-spacing: 2px;
  }
`

export const SubHeader = styled.p`
  color: ${(props) => props.subHeaderColor || theme.white};
  text-align: center;
  font-feature-settings: 'liga' off;
  font-family: 'MatterRegular';
  font-size: 20px;
  font-style: normal;
  line-height: 140%;
  max-width: 450px;
  b {
    font-family: 'MatterBold';
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 18px;
  }
`

export const Time = styled.p`
  color: ${(props) => props.timeColor || theme.white};
  text-align: center;
  margin: 0px;
  font-family: 'P22MackinacProBold';
  font-size: 34px;
  line-height: 110%;
  text-transform: uppercase;
`
export const CountDownContainer = styled.div`
  margin: auto 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  @media (max-width: ${breakpoints.s}px) {
    padding-top: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
  }
`
export const Label = styled.p`
  font-family: 'MatterBold';
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 1.4px;
  margin: 0px;
  text-align: center;
  color: ${(props) => props.labelColor || theme.white};
  @media (max-width: ${breakpoints.m}px) {
    font-family: 12px;
    line-height: 16px;
    letter-spacing: 1.2px;
  }
`
export const ColonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
`
export const TextContainer = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: auto;
  @media (max-width: ${breakpoints.s}px) {
    width: 100%;
  }
`

export const BuyNowContainer = styled.div`
  text-align: center;
  cursor: pointer;
  @media (max-width: ${breakpoints.s}px) {
    width: 100%;
  }
`
export const BuyNowLink = styled(Link)`
  display: inline-block;
  background-color: ${(props) => props.ctaBgColor || theme.coral};
  border-radius: 28px;
  border: none;
  text-decoration: none;
  padding: ${(props) => (props.big ? '12px 64px' : '10px 30px')};
  margin-right: ${(props) => (props.marginRight ? '16px' : '0px')};
  &:hover {
    cursor: pointer;
    background-color: ${(props) => darken(0.1, props.ctaBgColor || theme.coral)};
  }
  &:focus {
    outline: none;
    box-shadow: ${(props) => `0 0 0 0.2rem ${lighten(0.1, props.ctaBgColor || theme.coral)}`};
  }
  @media (max-width: 850px) {
    width: 100%;
    font-size: 15px;
    line-height: 19px;
    letter-spacing: 0.08px;
    padding: ${(props) => (props.big ? '13px 64px' : '13px 20px')};
  }
  @media (max-width: ${breakpoints.s}px) {
    &:hover {
      cursor: pointer;
      outline: none;
    }
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
`

export const BuyNowText = styled.p`
  margin: 0px;
  color: ${(props) => props.ctaTextColor || theme.white};
  text-align: center;
  font-family: 'MatterRegular';
  font-size: 18px;
  font-style: normal;
  text-decoration: none;
  font-weight: 700;
  line-height: 20.68px;
  letter-spacing: 0.081px;
  @media (max-width: ${breakpoints.s}px) {
    color: ${(props) => props.ctaTextColorMobile || theme.white};
    line-height: 19.598px;
    letter-spacing: 0.077px;
  }
`
export const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 4px;
  width: 80px;
  margin-top: 0px;
  @media (max-width: ${breakpoints.s}px) {
    width: 48px;
  }
`

export const HideOnMobile = styled.div`
  display: block;
  @media (max-width: ${breakpoints.s}px) {
    display: none;
  }
`
export const HideOnDesktop = styled.div`
  display: none;
  @media (max-width: ${breakpoints.s}px) {
    display: block;
  }
`
export const TimeContainer = styled.div`
  display: flex;
  flex-direction: row;
`
